import { StylesConfig } from 'react-select'

const colourStyles: StylesConfig = {
    control: styles => ({
        ...styles,
        backgroundColor: 'white',
        fontWeight: 'medium',
        borderColor: '#333333',
        fontFamily: 'var(--font-mmc)',
        borderRadius: '0',
        height: '40px',
    }),
    option: (styles, { isFocused, isSelected }) => {
        return {
            ...styles,
            borderRadius: '0',
            backgroundColor: isSelected ? '#999999' : isFocused ? '#eee' : '#fff',
            color: isSelected ? '#fff' : '#999999',
        }
    },
    singleValue: styles => {
        return {
            ...styles,
            borderRadius: '0',
            fontWeight: 'medium',
            fontFamily: 'var(--font-mmc)',
        }
    },
    placeholder: styles => {
        return {
            ...styles,
            borderRadius: '0',
            fontFamily: 'var(--font-mmc)',
            color: '#9ca3af',
        }
    },
    indicatorSeparator: () => {
        return {
            display: 'none',
        }
    },
    dropdownIndicator: styles => {
        return {
            ...styles,
            color: '#999999',
        }
    },
    menu: styles => {
        return {
            ...styles,
            borderRadius: '0',
            border: 'none',
            boxShadow: 'none',
        }
    },
    menuList: styles => {
        return {
            ...styles,
            padding: '0',
            margin: '0',
            boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
        }
    },
}

export default colourStyles
